import {
  RESET_STATE,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  NETWORK_ERROR
} from "../constants/ActionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  message: "",
  lastActionType: "",
  isNetworkError: false
};

export default (state = { ...INIT_STATE }, action) => {
  state.lastActionType = action.type;
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: "", message: "", loading: true };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: "", message: "", loading: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, error: "", message: action.payload, loading: false };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, error: action.payload, message: "" };
    }
    case HIDE_MESSAGE: {
      return { ...state, loading: false, error: "", message: "" };
    }
    case RESET_STATE: {
      return { ...INIT_STATE };
    }
    case NETWORK_ERROR:
      return { ...state, isNetworkError: action.payload };
    default:
      return state;
  }
};
